const es = {
  'welcomeModal.slide1.text': 'Visita el Centro Creativo y elige entre las recomendaciones de Piper o de los cientos de plantillas listas para usar.',
  'welcomeModal.slide2.text': 'Sigue las recomendaciones de Piper de “Buenos momentos para publicar” para crar, programar y organizar tu contenido y anuncios.',
  'welcomeModal.slide3.text': 'Crea anuncios fácilmente, revisa su rendimiento en redes sociales y administra tu presupuesto de publicidad.',
  'welcomeModal.slide4.text': '<TryPiperText>¡Prueba Social Piper hoy!</TryPiperText> <TrialText>Prueba gratuita de {trialDays} días</TrialText> <TrialHelpText>Sin riesgo. Cancela en cualquier momento. Se requiere una tarjeta.</TrialHelpText>',
  'welcomeModal.createAccount.button.text': 'Crear cuenta',
};

export default es;
